import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getClassicEventAnchor, getClassicRecurAnnually } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import ClassicVirtualAnchoredDelayActionCard from 'automation-ui-action-features/actions/classic-virtual-anchored-delay/ClassicVirtualAnchoredDelayActionCard';
import wireFlow from 'automation-ui-canvas/decorators/WiredFlowDecorator';
export default compose(withRouter, wireFlow, connect((__state, {
  flow
}) => {
  const eventAnchor = getClassicEventAnchor(flow);
  const recurAnnually = getClassicRecurAnnually(flow);
  return {
    eventAnchor,
    recurAnnually
  };
}))(ClassicVirtualAnchoredDelayActionCard);